(() => {
  const init = (root) => {
    if (root.dataset.smartHomeDirectoryReady === 'true') return;
    root.dataset.smartHomeDirectoryReady = 'true';

    const filters = Array.from(root.querySelectorAll('[data-smart-home-filter]'));
    const items = Array.from(root.querySelectorAll('[data-smart-home-item]'));
    const heading = root.querySelector('[data-smart-home-results-heading]');
    const status = root.querySelector('[data-smart-home-results-status]');
    const searchForm = root.querySelector('[data-smart-home-search-form]');
    const searchInput = root.querySelector('[data-smart-home-search]');
    const clearButton = root.querySelector('[data-smart-home-search-clear]');
    const noResults = root.querySelector('[data-smart-home-no-results]');

    if (!filters.length || !items.length) return;

    let activeBrand = 'all';
    let activeLabel = 'All Smart Home Skins';

    const normalize = (value) => String(value || '').trim().toLowerCase();

    const applyFilters = () => {
      const query = normalize(searchInput?.value);
      let visible = 0;

      items.forEach((item) => {
        const card = item.querySelector('[data-search]');
        const searchableText = normalize(`${card?.dataset.search || ''} ${item.dataset.smartHomeBrand || ''}`);
        const matchesBrand = activeBrand === 'all' || item.dataset.smartHomeBrand === activeBrand;
        const matchesSearch = !query || searchableText.includes(query);
        const show = matchesBrand && matchesSearch;

        item.hidden = !show;
        if (show) visible += 1;
      });

      filters.forEach((button) => {
        const active = button.dataset.smartHomeFilter === activeBrand;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (heading) {
        heading.textContent = activeBrand === 'all' ? 'All Smart Home Skins' : `${activeLabel} Smart Home Skins`;
      }
      if (status) {
        const searchStatus = query ? ` matching “${searchInput.value.trim()}”` : '';
        status.textContent = `${visible} ${visible === 1 ? 'item' : 'items'}${searchStatus}, newest first`;
      }
      if (clearButton) clearButton.hidden = !query;
      if (noResults) noResults.hidden = visible !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeBrand = button.dataset.smartHomeFilter || 'all';
        activeLabel = button.dataset.label || 'All Smart Home Skins';
        applyFilters();
      });
    });

    searchForm?.addEventListener('submit', (event) => event.preventDefault());
    searchInput?.addEventListener('input', applyFilters);
    clearButton?.addEventListener('click', () => {
      searchInput.value = '';
      applyFilters();
      searchInput.focus();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sw-smart-home-directory]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
